import React from 'react';
import { withTranslation } from "react-i18next";
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const Error404 = (props) => {
    return (
        <div className='error-404'>
            <div className="container">
                <div className="error-sub d-flex">
                    <div className="error-sub-left">
                        <h1>404</h1>
                        <h2>{props.t("something_went")}</h2>
                        <h2><strong>{props.t("wrong!")}</strong></h2>
                        <NavLink to={'/'} className={'back-homepage'}>{props.t("back_to_homepage")}</NavLink>
                    </div>
                    <div className="error-sub-right">
                        <img
            loading="lazy" alt='Error' className='img-fluid' src='/assets/images/error404.png' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(Error404);